const BASE_PATH = "/oauth2";
const APP_PATH = `${BASE_PATH}/app`;
const API_PATH = `${BASE_PATH}/api`;

export const ENDPOINTS = {
  REFRESH_TOKEN: `${API_PATH}/token`,
  USER_INFO: `${API_PATH}/userinfo`,
  UPDATE_USER: `${API_PATH}/user`,
  RESET_PASSWORD: `${API_PATH}/user/resetpassword`,
  DELETE_ADDRESS: `${API_PATH}/user/address`,
  ADD_ADDRESS: `${API_PATH}/user/address`,
  UPDATE_ADDRESS: `${API_PATH}/user/address`,
  PRESIGNED_URL: `${API_PATH}/user/presignedurl`,
  UPDATE_LANGUAGE: `${API_PATH}/user/language`,
  UPDATE_TIMEZONE: `${API_PATH}/user/timezone`,
  SEND_SECURITY_CODE: `${API_PATH}/user/otp/send`,
  PHONEOREMAIL_EXIST: `${API_PATH}/user/emailphoneexist`,
  LOGIN_DEVICE_INFO: `${API_PATH}/user/logininfo`,
  SET_PASSWORD_CODE: `${API_PATH}/user/resetpasswordconfirm`,
  SET_PASSWORD: `${API_PATH}/user/updatepassword`,
  SIGNOUT_EVERYWHERE: `${API_PATH}/revoke/user`,
  SIGNOUT_SESSION: `${API_PATH}/revoke/user/session`,
  COUNTRY: `${APP_PATH}/countries`,
  STATE: `${APP_PATH}/states`,
};
